import {
  apiGetSchoolData,
  apiCreateGroup,
  apiDeleteGroup,
  apiUpdateGroup
} from '../../common/api/school'

let id = 0

const fetchGroups = schoolId => ({
  requestPrefix: 'GROUPS_STORE:FETCHING',
  request: () =>
    apiGetSchoolData(schoolId, {
      include:
        'school.groups,school.group.names,school.group.mis,school.group.policy.editable_properties,school,school.group.visibility,school.group.counters,school.group.category,school.group_categories'
    })
})

const createGroup = (schoolId, data) => ({
  requestPrefix: 'GROUPS_STORE:CREATE',
  params: { ...data, id: id++ },
  request: () =>
    apiCreateGroup(schoolId, data, {
      include:
        'group.names,group.mis,group.visibility,group.stats,group.policy.editable_properties'
    })
})

const deleteGroup = id => ({
  requestPrefix: 'GROUPS_STORE:DELETE',
  params: { id },
  request: () => apiDeleteGroup(id)
})

const updateGroup = (id, data) => ({
  requestPrefix: 'GROUPS_STORE:UPDATE',
  params: { id },
  request: () =>
    apiUpdateGroup(
      { id, ...data },
      {
        include:
          'group.names,group.mis,group.visibility,group.stats,group.policy.editable_properties'
      }
    )
})

export { fetchGroups, createGroup, deleteGroup, updateGroup }
